export default __webpack_public_path__ + "static/media/JosephSassoon.5f3b655f.png";